import * as React from 'react';
import { ListItem } from '../List';
export const MenuItem = (props) => {
    const { icon, children, onClick, element, close, active, action, gutter } = props;
    return (React.createElement(ListItem, { onClick: () => {
            onClick && onClick();
            close && close();
        }, avatar: icon, element: element, selected: active, action: action, gutter: gutter }, children));
};
//# sourceMappingURL=MenuItem.js.map